import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo_escalade.png'


const _withScopeId = n => (_pushScopeId("data-v-5edcf987"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logoContainer" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "logo",
      alt: "Course de l'escalade",
      src: _imports_0,
      onDblclick: _cache[0] || (_cache[0] = $event => (_ctx.logCameraPos(_ctx.row,$event)))
    }, null, 32)
  ]))
}